import { motion } from "framer-motion";
import Navbar from "@/components/site/Navbar";
import { Seo } from "@/components/site/Seo";
import { Team } from "@/components/site/Team";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";

export default function TeamPage() {
  return (
    <div className="min-h-screen bg-[#F8FAFC] text-[#334155] font-body" data-testid="team-page">
      <Seo
        title="Meet the Team | Happy Tiddlers Swim School"
        description="Meet Team Tiddler — the warm, qualified swim teachers and Happiness Heroes behind Happy Tiddlers Swim School in Barton-le-Clay, Bedfordshire."
        path="/team"
      />
      <Navbar />
      <main>
        <section className="relative overflow-hidden bg-[#0A2540] pt-20 md:pt-28 pb-16 md:pb-20">
          <div className="blob absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#0EA5E9]/20" aria-hidden="true" />
          <div className="blob absolute -bottom-32 -left-24 w-96 h-96 rounded-full bg-[#FF7A1A]/10" aria-hidden="true" />
          <div className="container mx-auto px-6 md:px-12 relative">
            <motion.div
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="max-w-3xl"
            >
              <span className="text-sm text-[#38BDF8] tracking-[0.2em] uppercase font-bold">Meet Team Tiddler</span>
              <h1 className="mt-4 font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight text-white leading-[1.05]">
                The friendly faces behind every splash
              </h1>
              <p className="mt-6 text-lg text-[#CBD5E1] leading-relaxed">
                Warm, qualified and genuinely passionate — our team is the heart of Happy Tiddlers.
                They're the reason nervous first-timers become confident swimmers, and why families
                keep coming back year after year.
              </p>
            </motion.div>
          </div>
        </section>

        <Team hideHeader />

        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
